// THIS FOR Single Approval
import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  ViewChild,
  SimpleChanges,
  EventEmitter
} from '@angular/core';

import { HttpClient } from '@angular/common/http';
import {map, switchMap, tap} from 'rxjs/operators';

import * as BpmnJS from 'bpmn-js/dist/bpmn-navigated-viewer.production.min.js';
import { from, Observable, Subscription } from 'rxjs';
import {data} from 'jquery';

@Component({
  selector: 'app-diagram-tes',
  template: `
    <div class="row">
      <div class="col-12" style="height: 450px">
        <div #ref class="diagram-container"></div>
      </div>
      <div class="col-12">
        <div style="position: absolute;bottom: 50px;right: 20px;display: grid;grid-gap: 3px;">
          <button id="btnzoomin" class="btn btn-primary btn-icon btn-sm" (click)="zoomIn()">
            <i class="ki ki-plus"></i>
          </button>
          <button id="btnfit" class="btn btn-primary btn-icon btn-sm" (click)="zoomOut()">
            <i class="ki ki-minus"></i>
          </button>
          <button id="btnzoomout" class="btn btn-primary btn-icon btn-sm" (click)="zoomReset()">
            <i class="ki ki-refresh"></i>
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
    .diagram-container {
      height: 100%;
      width: 100%;
    }
    `,
    `
    .bac {
        background-color: red;
    }`
  ]
})
export class DiagramTesComponent implements AfterContentInit, OnChanges, OnDestroy {
  private bpmnJS: BpmnJS;
  private overlays: any;
  private elementRegis: any;
  cnvs = 0;

  @ViewChild('ref', { static: true }) private el: ElementRef;
  @Output() private importDone: EventEmitter<any> = new EventEmitter();

  @Input() private url: string;
  @Input() private urlSec: string;
  @Input() private myHeader: any;
  @Input() private showUrlSec: string;

  constructor(private http: HttpClient) {

    this.bpmnJS = new BpmnJS();

    this.bpmnJS.on('import.done', ({ error }) => {
      if (!error) {
        this.bpmnJS.get('canvas').zoom('fit-viewport');
        this.overlays = this.bpmnJS.get('overlays');
        this.elementRegis = this.bpmnJS.get('elementRegistry');
        this.cnvs = this.bpmnJS.get('canvas').zoom('fit-viewport');
      }
    });
  }

  ngAfterContentInit(): void {
    this.bpmnJS.attachTo(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.showUrlSec) {
      if (changes.urlSec) {
        this.loadUrlSec(changes.urlSec.currentValue);
      }
    } else {
      if (changes.url) {
        this.loadUrl(changes.url.currentValue);
      }
    }
  }

  ngOnDestroy(): void {
    this.bpmnJS.destroy();
  }

  zoomIn() {
    if (this.cnvs < 1.5) {
      this.cnvs += 0.1;
    }
    this.bpmnJS.get('canvas').zoom(this.cnvs);
  }

  zoomOut() {
    if (this.cnvs > 0.3) {
      this.cnvs -= 0.1;
    }
    this.bpmnJS.get('canvas').zoom(this.cnvs);
  }

  zoomReset() {
    this.cnvs = this.bpmnJS.get('canvas').zoom('fit-viewport');
    this.bpmnJS.get('canvas').zoom(this.cnvs);
  }

  loadUrlSec(url: string): Subscription {
    const urlXml = `${this.url}/xml`;
    const urlStatic = `${url}`;

    return (
      this.http.get(urlXml, {
        headers: this.myHeader,
        responseType: 'text'
      }).pipe(
        switchMap((xml: string) => this.importDiagram(xml)),
        map(result => result.warnings),
      ).subscribe(
        async (warnings) => {
          const dataStatic = await this.http.get(urlStatic, {
            headers: this.myHeader,
          }).pipe(
            map((res: any) => {
              return {
                tasks: res.data
              };
            })
          ).toPromise();
          for (const key in dataStatic.tasks) {
            let shape = this.elementRegis.get(dataStatic.tasks[key].id);
            let overlayHtml = $('<div id="' + key + '" style="cursor: pointer"><a class="badge badge-primary">' + dataStatic.tasks[key].instances + '</a></div>')
              .css({
                width: shape.width,
                heigth: shape.heigth
              });

            this.overlays.add(dataStatic.tasks[key].id, {
              position: {
                top: 0,
                left: 0
              },
              html: overlayHtml
            });

            overlayHtml.click((e) => {
              this.importDone.emit({
                type: 'click',
                warnings: key
              });
            });
          }

          this.importDone.emit({
            type: 'success',
            warnings
          });
        },
        (err) => {
          this.importDone.emit({
            type: 'error',
            error: err
          });
        }
      )
    );
  }

  /**
   * Load diagram from URL and emit completion event
   */
  loadUrl(url: string): Subscription {
    const urlXml = `${url}/xml`;
    const urlStatic = `${url}/statistic`;
    return (
      this.http.get(urlXml, {
        headers: this.myHeader,
        responseType: 'text'
      }).pipe(
        switchMap((xml: string) => this.importDiagram(xml)),
        map(result => result.warnings),
      ).subscribe(
        async (warnings) => {

          const dataStatic = await this.http.get(urlStatic, {
            headers: this.myHeader,
          }).pipe(
            map((res: any) => {
              return {
                tasks: res.data.tasks
              };
            })
          ).toPromise();

          for (const key in dataStatic.tasks) {
            let shape = this.elementRegis.get(key);
            let overlayHtml = $('<div id="' + key + '" style="cursor: pointer"><a class="badge badge-primary">' + dataStatic.tasks[key] + '</a></div>')
              .css({
                width: shape.width,
                heigth: shape.heigth
              });

            this.overlays.add(key, {
              position: {
                top: 0,
                left: 0
              },
              html: overlayHtml
            });

            overlayHtml.click((e) => {
              this.importDone.emit({
                type: 'click',
                warnings: key
              });
            });

          }

          this.importDone.emit({
            type: 'success',
            warnings
          });
        },
        (err) => {
          this.importDone.emit({
            type: 'error',
            error: err
          });
        }
      )
    );
  }

  private importDiagram(xml: string): Observable<{warnings: Array<any>}> {
    return from(this.bpmnJS.importXML(xml) as Promise<{warnings: Array<any>}>);
  }
}
